import { ORGANIZATION_ROLES } from '@/constants/roles';
import { currentUserIsBasic, currentUserIsDoctor, currentUserIsNurse, currentUserIsSuperAdmin, organizationRole } from '@/globalHelpers/userRole';

export const routePrefix = () => {
  /**
   * NOTE:
   * Instead of manually declaring multiple routes for each role 
   * (Org Owner, Doctor, Nurse, etc.), use `routePrefix()` to dynamically 
   * generate the route name.
   *
   * Pattern: <RolePrefix><RouteName>
   *
   * Example:
   *  this.$router.push({ name: `${routePrefix()}DispenseRequestCreate` });
   *
   * Which could resolve to:
   *  - OrgOwnerDispenseRequestCreate
   *  - DoctorDispenseRequestCreate
   *  - NurseDispenseRequestCreate
   */
  const ROUTE_PREFIX_NAMES = {
    ORG_OWNER: 'OrgOwner',
    NURSE: 'Nurse',
    DOCTOR: 'Doctor',
    BASIC: 'Basic',
    SUPER_ADMIN: 'SuperAdmin',
  };

  if (currentUserIsSuperAdmin()) {
    // Super Admins are not tied to a specific organization role,
    // so we return early with a fixed prefix to avoid unnecessary
    // role checks and mapping logic below.
    return ROUTE_PREFIX_NAMES.SUPER_ADMIN;
  }

  const orgRole = organizationRole();

  if (!orgRole) return '';

  const roleMap = {
    [ORGANIZATION_ROLES.ORG_OWNER]: ROUTE_PREFIX_NAMES.ORG_OWNER,
    [ORGANIZATION_ROLES.STAFF]: () => {
      if (currentUserIsNurse()) return ROUTE_PREFIX_NAMES.NURSE;
      if (currentUserIsDoctor()) return ROUTE_PREFIX_NAMES.DOCTOR;
      if (currentUserIsBasic()) return ROUTE_PREFIX_NAMES.BASIC;
      return '';
    },
  };

  if (roleMap[orgRole]) {
    const value = roleMap[orgRole];
    return typeof value === 'function' ? value() : value;
  }

  return '';
};